export default {
  COORDENADOR: 'COORDENADOR',
  OPERADOR: 'OPERADOR'
}
